let $imageContainerList = document.querySelectorAll('.licenses__container-item img');
let $modalImage = document.querySelector('#modal-image img')
$imageContainerList.forEach(container=>{
    container.addEventListener('click',event=>{
        $modalImage.src = event.currentTarget.src;
        modals.open('modal-image');
    })
})
